
import FormFeedback from '../common/FormFeedback.vue';
import axios from 'axios';
import {Vue, servicesURL, cookies, webClientID, requestHeaders, getCookie, headers} from '../../constants/constants'
export default Vue.component('change-email', {
	components: {
		'form-feedback': FormFeedback
	},
	props: {
		currentEmail: {
			required: true,
			type: String
		}
	},
	data () {
		return {
			email: null,
			loading: false
		}
	},
	mounted () {
		this.email = this.currentEmail
	},
	methods: {
		clearErrors () {
			this.$refs.feedback.clear()
		},
		submitChangeEmail () {
			this.loading = true
			this.$refs.feedback.clear()
		axios({
			method: 'PUT',
			url: servicesURL.profile.changeEmail,
			headers: headers,
			data: JSON.stringify({ email: this.email })
		})
			.then(res => {
				this.$refs.feedback.showSuccess('Email changed successfully');

				//complete
				this.loading = false
			})
			.catch(error => {
				console.log("error", error.responseText);
				this.$refs.feedback.showError(error.response.data.error);
			});

		}
	}
})
